"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: gift-card/gift-card-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fgift-card%2Fgift-card-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.GiftCardServiceClient = exports.SetGiftCardArchiveStatusResponse = exports.SetGiftCardArchiveStatusRequest = exports.ListGiftCardsResponse = exports.ListGiftCardsRequest = exports.GetGiftCardResponse = exports.GetGiftCardRequest = exports.OrderResponse = exports.OrderRequest = exports.GetCatalogResponse = exports.GetCatalogRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const amount_1 = require("../common/amount");
const catalog_1 = require("./catalog");
const gift_card_1 = require("./gift-card");
const protobufPackage = 'com.step.giftcard.proto';
function createBaseGetCatalogRequest() {
    return { type: catalog_1.CatalogType.INVALID_CATALOG_TYPE };
}
exports.GetCatalogRequest = {
    fromJSON(object) {
        const message = {
            type: isSet(object.type)
                ? (0, catalog_1.catalogTypeFromJSON)(object.type)
                : catalog_1.CatalogType.INVALID_CATALOG_TYPE,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== catalog_1.CatalogType.INVALID_CATALOG_TYPE) {
            obj.type = (0, catalog_1.catalogTypeToJSON)(message.type);
        }
        return obj;
    },
    create(base) {
        return exports.GetCatalogRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetCatalogRequest();
        message.type = object.type ?? catalog_1.CatalogType.INVALID_CATALOG_TYPE;
        return message;
    },
};
function createBaseGetCatalogResponse() {
    return { catalog: catalog_1.GiftCardCatalog.fromPartial({}) };
}
exports.GetCatalogResponse = {
    fromJSON(object) {
        const message = {
            catalog: isSet(object.catalog)
                ? catalog_1.GiftCardCatalog.fromJSON(object.catalog)
                : catalog_1.GiftCardCatalog.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.catalog !== undefined) {
            obj.catalog = catalog_1.GiftCardCatalog.toJSON(message.catalog);
        }
        return obj;
    },
    create(base) {
        return exports.GetCatalogResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetCatalogResponse();
        message.catalog = (object.catalog !== undefined && object.catalog !== null)
            ? catalog_1.GiftCardCatalog.fromPartial(object.catalog)
            : catalog_1.GiftCardCatalog.fromPartial({});
        return message;
    },
};
function createBaseOrderRequest() {
    return {
        productId: '',
        purchaseAmount: amount_1.Amount.fromPartial({}),
        cardValue: amount_1.Amount.fromPartial({}),
    };
}
exports.OrderRequest = {
    fromJSON(object) {
        const message = {
            productId: isSet(object.productId) ? globalThis.String(object.productId) : '',
            purchaseAmount: isSet(object.purchaseAmount)
                ? amount_1.Amount.fromJSON(object.purchaseAmount)
                : amount_1.Amount.fromPartial({}),
            cardValue: isSet(object.cardValue)
                ? amount_1.Amount.fromJSON(object.cardValue)
                : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.productId !== '') {
            obj.productId = message.productId;
        }
        if (message.purchaseAmount !== undefined) {
            obj.purchaseAmount = amount_1.Amount.toJSON(message.purchaseAmount);
        }
        if (message.cardValue !== undefined) {
            obj.cardValue = amount_1.Amount.toJSON(message.cardValue);
        }
        return obj;
    },
    create(base) {
        return exports.OrderRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOrderRequest();
        message.productId = object.productId ?? '';
        message.purchaseAmount = (object.purchaseAmount !== undefined && object.purchaseAmount !== null)
            ? amount_1.Amount.fromPartial(object.purchaseAmount)
            : amount_1.Amount.fromPartial({});
        message.cardValue = (object.cardValue !== undefined && object.cardValue !== null)
            ? amount_1.Amount.fromPartial(object.cardValue)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseOrderResponse() {
    return { card: gift_card_1.GiftCard.fromPartial({}) };
}
exports.OrderResponse = {
    fromJSON(object) {
        const message = {
            card: isSet(object.card) ? gift_card_1.GiftCard.fromJSON(object.card) : gift_card_1.GiftCard.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.card !== undefined) {
            obj.card = gift_card_1.GiftCard.toJSON(message.card);
        }
        return obj;
    },
    create(base) {
        return exports.OrderResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOrderResponse();
        message.card = (object.card !== undefined && object.card !== null)
            ? gift_card_1.GiftCard.fromPartial(object.card)
            : gift_card_1.GiftCard.fromPartial({});
        return message;
    },
};
function createBaseGetGiftCardRequest() {
    return { orderId: '' };
}
exports.GetGiftCardRequest = {
    fromJSON(object) {
        const message = {
            orderId: isSet(object.orderId) ? globalThis.String(object.orderId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.orderId !== '') {
            obj.orderId = message.orderId;
        }
        return obj;
    },
    create(base) {
        return exports.GetGiftCardRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetGiftCardRequest();
        message.orderId = object.orderId ?? '';
        return message;
    },
};
function createBaseGetGiftCardResponse() {
    return { card: gift_card_1.GiftCard.fromPartial({}) };
}
exports.GetGiftCardResponse = {
    fromJSON(object) {
        const message = {
            card: isSet(object.card) ? gift_card_1.GiftCard.fromJSON(object.card) : gift_card_1.GiftCard.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.card !== undefined) {
            obj.card = gift_card_1.GiftCard.toJSON(message.card);
        }
        return obj;
    },
    create(base) {
        return exports.GetGiftCardResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetGiftCardResponse();
        message.card = (object.card !== undefined && object.card !== null)
            ? gift_card_1.GiftCard.fromPartial(object.card)
            : gift_card_1.GiftCard.fromPartial({});
        return message;
    },
};
function createBaseListGiftCardsRequest() {
    return {};
}
exports.ListGiftCardsRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.ListGiftCardsRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseListGiftCardsRequest();
        return message;
    },
};
function createBaseListGiftCardsResponse() {
    return { giftCards: [] };
}
exports.ListGiftCardsResponse = {
    fromJSON(object) {
        const message = {
            giftCards: globalThis.Array.isArray(object?.giftCards)
                ? object.giftCards.map((e) => gift_card_1.GiftCard.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.giftCards?.length) {
            obj.giftCards = message.giftCards.map((e) => gift_card_1.GiftCard.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.ListGiftCardsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseListGiftCardsResponse();
        message.giftCards = object.giftCards?.map((e) => gift_card_1.GiftCard.fromPartial(e)) || [];
        return message;
    },
};
function createBaseSetGiftCardArchiveStatusRequest() {
    return { orderId: '', archive: false };
}
exports.SetGiftCardArchiveStatusRequest = {
    fromJSON(object) {
        const message = {
            orderId: isSet(object.orderId) ? globalThis.String(object.orderId) : '',
            archive: isSet(object.archive) ? globalThis.Boolean(object.archive) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.orderId !== '') {
            obj.orderId = message.orderId;
        }
        if (message.archive !== false) {
            obj.archive = message.archive;
        }
        return obj;
    },
    create(base) {
        return exports.SetGiftCardArchiveStatusRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetGiftCardArchiveStatusRequest();
        message.orderId = object.orderId ?? '';
        message.archive = object.archive ?? false;
        return message;
    },
};
function createBaseSetGiftCardArchiveStatusResponse() {
    return {};
}
exports.SetGiftCardArchiveStatusResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SetGiftCardArchiveStatusResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSetGiftCardArchiveStatusResponse();
        return message;
    },
};
/**
 * Gift Card Service API.
 */
class GiftCardServiceClient {
    rpc;
    name = 'com.step.giftcard.proto.GiftCardService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/gift-card';
    methods = [{
            name: 'GetCatalog',
            requestType: exports.GetCatalogRequest,
            responseType: exports.GetCatalogResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'Order',
            requestType: exports.OrderRequest,
            responseType: exports.OrderResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetGiftCard',
            requestType: exports.GetGiftCardRequest,
            responseType: exports.GetGiftCardResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'ListGiftCards',
            requestType: exports.ListGiftCardsRequest,
            responseType: exports.ListGiftCardsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'SetGiftCardArchiveStatus',
            requestType: exports.SetGiftCardArchiveStatusRequest,
            responseType: exports.SetGiftCardArchiveStatusResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Gets a catalog.
     */
    getCatalog(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Orders a gift card.
     */
    order(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Gets an ordered gift card.
     */
    getGiftCard(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Lists all user's gift cards.
     */
    listGiftCards(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Update the archive status of a users gift card.
     */
    setGiftCardArchiveStatus(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.GiftCardServiceClient = GiftCardServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=gift-card-service.js.map